import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * PageHeader — a slim breadcrumb strip that sits below the fixed navbar.
 * It does NOT duplicate the section heading (kept intentionally minimal so
 * the existing section components own the page title visually).
 */
export default function PageHeader({ title, breadcrumb }) {
  return (
    <div
      data-testid="page-header"
      className="relative pt-28 sm:pt-32 pb-2"
    >
      <div className="max-page container-px">
        <nav
          className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-muted-foreground"
          aria-label="Breadcrumb"
          data-testid="breadcrumb"
        >
          <Link to="/" className="hover:text-foreground transition-colors">Home</Link>
          {(breadcrumb || [{ label: title }]).map((b, i, arr) => (
            <React.Fragment key={i}>
              <ChevronRight className="w-3 h-3 opacity-50" />
              {b.to && i < arr.length - 1 ? (
                <Link to={b.to} className="hover:text-foreground transition-colors">{b.label}</Link>
              ) : (
                <span className="text-foreground">{b.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  );
}
